import { reportSPManangerReducer } from "../reducer/ReportSPManangerReducer";

export const reducer = reportSPManangerReducer;
